import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPremiumLock = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Frame",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M12.6667 7.16668H13.3333C13.7015 7.16668 14 7.46514 14 7.83334V14.5C14 14.8682 13.7015 15.1667 13.3333 15.1667H2.66667C2.29848 15.1667 2 14.8682 2 14.5V7.83334C2 7.46514 2.29848 7.16668 2.66667 7.16668H3.33333V6.50001C3.33333 3.92268 5.42267 1.83334 8 1.83334C10.5773 1.83334 12.6667 3.92268 12.6667 6.50001V7.16668ZM11.3333 7.16668V6.50001C11.3333 4.65906 9.84093 3.16668 8 3.16668C6.15905 3.16668 4.66667 4.65906 4.66667 6.50001V7.16668H11.3333ZM7.33333 9.83334V12.5H8.66667V9.83334H7.33333Z",
			fill: "#F7CA4F"
		})
	})
});
export default SvgPremiumLock;
